const MULTI_PAYMENT_FLOW_TABS = {
    ONE_TIME: 0,
    MULTI: 1
};
export default MULTI_PAYMENT_FLOW_TABS;
